import React from "react";
import { Link } from "react-router-dom";
import "./WideRangeSelection.css";
import cartIcon from "../assets/cart.svg";
import room1 from "../assets/room1.png";
import room2 from "../assets/room2.png";
import room3 from "../assets/room3.png";
import room4 from "../assets/room4.png";
import room5 from "../assets/room5.png";
import room6 from "../assets/room6.png";
import nippon from "../assets/nippon.png";
import berger from "../assets/berger.png";
import glamur from "../assets/glamur.png";
import dulux from "../assets/dulux.png";
import corona from "../assets/corona.png";
import reliance from "../assets/reliance.png";

const paintData = [
  { img: nippon, bg: room1, label: "Nippon Paints", link: "/estore?category=Nippon%20Paints" },
  { img: berger, bg: room2, label: "Berger Paints", link: "/estore?category=Berger%20Paints" },
  { img: glamur, bg: room3, label: "Glamur Paints", link: "/estore?category=Glamur%20Paints" },
  { img: dulux, bg: room4, label: "Dulux Paints", link: "/estore?category=Dulux%20Paints" },
  { img: corona, bg: room5, label: "Corona Paints", link: "/estore?category=Corona%20Paints" },
  { img: reliance, bg: room6, label: "Reliance Paints", link: "/estore?category=Reliance%20Paints" },
];

const WideRangeSelection = () => {
  return (
    <div className="wide-container">
      <h2>Wide Range Of Selection</h2>
      <div className="paint-scroll">
        {paintData.map((item, index) => (
          <div key={index} className="paint-card">
            <img src={item.bg} alt="room" className="room-img" />
            <img src={item.img} alt="paint bucket" className="bucket-img" />
            <div className="label-cart">
              <span className="label">{item.label}</span>
              <Link to={item.link} className="cart-link" aria-label={`Open ${item.label} products`}>
                <img src={cartIcon} alt="Add to cart" className="cart-icon" />
              </Link>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default WideRangeSelection;
